import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Subject } from 'rxjs';
import { Gtp } from 'src/app/shared/gtp';

@Injectable({
  providedIn: 'root'
})
export class GruposReferenciasService {
  public firstFiltroForm;
  private filtroForm = new Subject<any>();

  public ContenidoTabla = null; //Valor Inicial para cargar el componente
  private ContenidoTablaObs = new Subject<any>(); //Valor modificado para cargar el componente
  public FormData = null; //Valor Inicial para cargar el componente
  private FormDataObs = new Subject<any>(); //Valor modificado para cargar el componente
  constructor(
    private gtp: Gtp,
    private http: HttpClient
  ) { }


  getFiltroForm(){
    return this.filtroForm.asObservable();
  }

  setFiltroForm(filtro){
    this.filtroForm.next(filtro);
  }

  getContenidoTablaObs() {
    return this.ContenidoTablaObs.asObservable();
  }
  
  setContenidoTabla(obj) {
      //console.log(obj)
      this.ContenidoTablaObs.next(obj);
  }

  getFormDataObs() {
    return this.FormDataObs.asObservable();
  }
  
  setFormData(obj) {
      //console.log(obj)
      this.FormDataObs.next(obj);
  }
  /* getGruposReferenciasListar(puntos=false){
    const showpuntos = (puntos) ? '?puntos=true' : '';
    return this.http.get(`${environment.baseUrl}inforef/gruposreferencias/${showpuntos}`);
  } */
  postGruposReferenciasListar(model){
    return this.http.post(`${environment.baseUrl}inforef/gruposreferencias`, model);
  }

  deleteGruposReferencias(id){
    return this.http.delete(`${environment.baseUrl}inforef/gruposreferencias/`+ id);

  }
}
